import * as React from "react";
import { useTelephony } from "../../../../context/TelephonyContext";
import { KontaktAktionen } from "../../detail/KontaktAktionen";
import { IcoAnruf, IcoMail } from "../../v3/vg3Icons";
import { useAktionsKnoepfe, type AktionsKnoepfeOptionen } from "../aktionsKnoepfe";

/**
 * Die zwei runden Knöpfe der Kontaktzeile im Handy-Kopf (Artifact
 * „Vorgangsdetail mobil", Artboard 1): Anrufen und Mail schreiben.
 *
 *  · ANRUFEN wählt wie die Aktionsleiste über `KontaktAktionen` (Zentrale
 *    oder Ansprechpartner). Die Nach-Anruf-Karte schlägt den Vorgang vor —
 *    und das gerade aufgeklappte To-do, wenn eines offen ist.
 *  · MAIL: Ohne To-dos gehört sie dem Vorgang. Mit To-dos gehört alles
 *    einem To-do (PO-Invariante) — dann öffnet der Knopf das Plus bei „Mail"
 *    und fragt nach dem To-do (`onMailMitTodos`, Plan PR 4).
 */
export const KopfKontaktKnoepfe: React.FC<{
    optionen: AktionsKnoepfeOptionen;
    canEdit: boolean;
    hatTodos: boolean;
    offenesTodoId: number | null;
    onMailMitTodos?: () => void;
}> = ({ optionen, canEdit, hatTodos, offenesTodoId, onMailMitTodos }) => {
    const { callNumber } = useTelephony();
    const { knoepfe, elemente } = useAktionsKnoepfe(optionen);
    if (!canEdit) return null;
    const mailOhneTodos = knoepfe.find((k) => k.key === "mail-neu")?.onClick;
    const mail = hatTodos ? onMailMitTodos : mailOhneTodos;
    const kontaktId = optionen.contactId ?? null;
    return (
        <span className="vg4m-kontakt-knoepfe">
            {kontaktId != null && (
                <KontaktAktionen
                    kontaktId={kontaktId}
                    kontaktName={optionen.contactName ?? null}
                    nur="phone"
                    label=""
                    ariaLabel="Anrufen"
                    className="vg4m-rund"
                    icon={<IcoAnruf size={18} />}
                    onCompose={() => undefined}
                    onCall={(nummer, name) =>
                        callNumber(nummer, name, { vorgangId: optionen.vorgangId, todoId: offenesTodoId })
                    }
                />
            )}
            {mail && (
                <button
                    type="button"
                    className="vg4m-rund"
                    aria-label="Mail schreiben"
                    title="Mail schreiben"
                    onClick={mail}
                >
                    <IcoMail size={18} />
                </button>
            )}
            {elemente}
        </span>
    );
};
